import { SpaceConsumer } from '@eggplant/context'
import {
  Icons,
  NavGroup,
  NavItemVerticalMini
} from '@eggplant/pattern-library'
import {
  LOGOUT_SPACE,
  renderLinkTo
} from '@eggplant/routing'
import { Match } from '@reach/router'
import { HiMiniCubeTransparent } from 'react-icons/hi2'
import { LiaCubesSolid } from 'react-icons/lia'

interface Props {
  base: string
  isCollapsed: boolean
}

const WILDCARD = '/*'

const SpacesNavGroup = ({
  base,
  isCollapsed
}: Props) => (
  <SpaceConsumer>
    {
      context =>
        <Match path={'/' + base + WILDCARD}>
          {
            ({
              match
            }) =>
              <NavGroup
                icon={<Icons.CircledSpace aria-hidden />}
                isCollapsed={isCollapsed}
                isCurrent={!!match}
                label={context.selectedSpaceName || 'Space'}
                labelCharLimit={7}
              >
                <NavItemVerticalMini
                  icon={<HiMiniCubeTransparent aria-hidden />}
                  isCollapsed={isCollapsed}
                  label='Space details'
                >
                  {renderLinkTo(`${base}/${context.selectedSpaceId}`)}
                </NavItemVerticalMini>
                <NavItemVerticalMini
                  icon={<LiaCubesSolid aria-hidden />}
                  isCollapsed={isCollapsed}
                  label='View all spaces'
                >
                  {renderLinkTo(`${base}/${LOGOUT_SPACE}`)}
                </NavItemVerticalMini>
              </NavGroup>
          }
        </Match>
    }
  </SpaceConsumer>
)

export default SpacesNavGroup
